/**
 * 파크웨이브 브랜드 · 멀티 사이트 배포 플래그.
 *
 * `REACT_APP_PARKWAVE_SITE`:
 * - `full` (기본): 전체 라우트, `/` 가 메인 랜딩
 * - `parking` | `am` | `arms` | `platform`: 동일 빌드로 Vercel 프로젝트를 나눌 때 루트 진입만 전용 허브로 고정
 */

export type ParkwaveSiteMode = 'full' | 'parking' | 'am' | 'arms' | 'platform';

const raw = (process.env.REACT_APP_PARKWAVE_SITE || 'full').trim().toLowerCase();

export const PARKWAVE_SITE: ParkwaveSiteMode = (
  ['full', 'parking', 'am', 'arms', 'platform'].includes(raw) ? raw : 'full'
) as ParkwaveSiteMode;

export const PARKWAVE_BRAND = {
  name: '파크웨이브',
  legalProduct: 'Parkwave',
  tagline: '기존 CCTV를, 판단하고 실행하는 운영 시스템으로',
  platformLabel: '공간 운영 AI 플랫폼',
  commercialNote:
    '기존 CCTV·관제를 유지한 채 단계적으로 도입합니다. API·SDK·운영 콘솔 구독과 견적·서비스 수준은 별도 계약입니다.',
} as const;

export const PARKWAVE_PATHS = {
  application: '/parkwave/application',
  industrialReports: '/parkwave/industrial-reports',
  parking: '/parkwave/parking',
  am: '/parkwave/am',
  military: '/parkwave/military',
} as const;
